export default {
  evidence_division: {
    id: "Id",
    code: "암호",
    name: "이름",
    description: "기술",
    active: "Active",
    createdAt: "작성 시간",
    updatedAt: "에 업데이트 됨",
    create: "새로운 기록 부 창조",
    update: "업데이트 기록부",
  }
}